import axios from 'axios'

/**
 * Landlord onboarding checklist tasks the browser reports (86bc2cgxd).
 */
export const SHARE_LINK_TASK = 'share_link'

/**
 * Fire-and-forget: the checklist is a nudge, so a failed request must never
 * surface to the landlord or interrupt what they were doing.
 */
export function recordOnboardingTask(taskKey) {
    return axios.post(window.route('onboarding.tasks.store'), { task: taskKey }).catch(() => {})
}
